import { Network, NetworkPublicInfo } from '@tribeplatform/gql-client/types'

const getSubdomain = (domainSubfolder, networkDomain) => {
  try {
    if (domainSubfolder) {
      const url = new URL(`https://${domainSubfolder}`)
      return {
        subfolder: url?.pathname === '/' ? '' : url?.pathname,
        domain: url?.host || networkDomain,
      }
    }
  } catch (err) {
    logger.error('Cannot parse maskDomain and subfolder from domainSubfolder')
  }
  return { subfolder: '', subfolderDomain: null, domain: networkDomain }
}

export const getDomainInfo = (network: Network | NetworkPublicInfo) => {
  const domainSubfolder = network?.domainSubfolder || network?.domain

  const { subfolder, domain } = getSubdomain(domainSubfolder, network?.domain)

  return {
    domain,
    subfolder,
  }
}
